<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { isMobile } from 'mobile-device-detect'
  import { wrapIframes, getScripts, removeScripts } from '@/helper'
  import postscribe from 'postscribe'

  export default {
    name: 'EditorModule',
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
      moduleId: Number,
    },
    data() {
      return {
        isMobile: isMobile,
      }
    },
    mounted() {
      if (window.CSPInterval) {
        clearInterval(window.CSPInterval)
      }
      window.CSPInterval = setInterval(() => {
        // Alle Elemente im Dokument auswählen
        const allElements = document.querySelectorAll('*')

        // Filtere die Elemente, die eine onclick-Eigenschaft haben
        const elementsWithOnClick = Array.from(allElements).filter(element => element.getAttribute('onclick') !== null)
        elementsWithOnClick.forEach(element => {
          const oldClick = element.getAttribute('onclick')
          element.removeAttribute('onclick')
          element.addEventListener('click', function(e) {
            e.preventDefault()
            eval(oldClick)
          })
        })
      }, 200)
      this.$nextTick(() => {
        const scripts = getScripts(this.options?.results, this.moduleId)
        const divId = `scripts-${ this.moduleId }`
        const nonce = 'bd5af2d76fe645c3d5d65f52a60f7a52'
        if (scripts.length) {
          const scriptInterval = setInterval(() => {
            const isLoaded = document.getElementById(divId)
            if (isLoaded) {
              scripts.forEach(script => {
                script = script.replace(/nonce="[^"]*"/, '')
                script = script.replace('<script', `<script nonce="${nonce}"`)
                postscribe(`#${ divId }`, script)
              })
              clearInterval(scriptInterval)
            }
          }, 200)
        }
      })
    },
    methods: {
      wrapIframes,
      removeScripts,
    },
  }
</script>
